let filterableTreeFactory = require('../../filterable-tree');
let rubrics = require('../../../../../signals/custom-order/rubrics');
let TreeInput = require('./tree-input');
let FilterByList = require('./filter-by-list');
let css = require('./rubrics-content.css');

let id = 'rubrics';
let basePath = ['order', 'rubrics', 'tree'];

class Rubrics {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({ css }, data));
    }
}

module.exports = {
    constructor: Rubrics,
    children: [
        {
            name: 'filterable-tree',
            component: filterableTreeFactory({
                basePath
            }),
            watcher: {
                isDisabled: ['order', 'isDisabled']
            },
            props: {
                id,
                onItemCheck: rubrics.onItemCheck,
                onSetAll: rubrics.onSetAll,
                minFilterLength: 3
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'filter-by-list',
            component: FilterByList,
            watcher: {
                isDisabled: ['order', 'isDisabled'],
                showFilterTreeInput: basePath.concat('showFilterTreeInput')
            }
        },
        {
            name: 'tree-input',
            component: TreeInput,
            props: {
                treeId: id,
                basePath
            },
            watcher: {
                haveUnrecognizedRubrics: ['order', 'computed', 'treeUpload', 'rubrics', 'haveUnrecognized'],
                unrecognizedRubrics: ['order', 'computed', 'treeUpload', 'rubrics', 'unrecognized'],
                recognizedRubrics: ['order', 'computed', 'treeUpload', 'rubrics', 'recognized'],
                showFilterTreeInput: basePath.concat('showFilterTreeInput')
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/rubrics/content/index.js